import React, { ReactNode } from 'react';
import { useAppContext } from '@prisjakt/ui-app-context';
import TextLink from '@prisjakt/ui-text-link';
import { CoreProperty } from '../types';

type TextListProps = {
  children: ReactNode[];
  maxItems?: number;
};

const TextList = ({ children, maxItems }: TextListProps) => {
  return (
    <>
      {children.slice(0, maxItems).map((child, i) => (
        <>
          {i > 0 && ', '}
          {child}
        </>
      ))}
      {children.length > (maxItems || 0) && `\u00A0…`}
    </>
  );
};

type ListPropertyProps = {
  property: {
    id: CoreProperty['id'];
    values: (string | null)[] | null;
    valueIds: (string | null)[] | null;
    categoryLinks: (string | null)[] | null;
    prettyTable: string | null;
  };
};

const ListProperty = ({ property }: ListPropertyProps) => {
  const { linkTo } = useAppContext();

  if (!property.values || !property.valueIds || !property.categoryLinks) {
    return <>{property.prettyTable}</>;
  }

  return (
    <TextList maxItems={3}>
      {property.values.map((value, i) =>
        property.valueIds?.[i] && property.categoryLinks?.[i] ? (
          <TextLink
            to={linkTo('productCollection', {
              pathName: property.categoryLinks?.[i],
              filters: [
                {
                  type: 'term',
                  property: property.id,
                  id: property.valueIds[i],
                },
              ],
            })}
          >
            {value}
          </TextLink>
        ) : (
          value
        )
      )}
    </TextList>
  );
};

export default ListProperty;
